/* tummy-cart.js — Cart drawer + mobile nav overrides */
(function () {
  var drawer = document.querySelector('.cart-drawer');
  if (!drawer) return;

  /* ── Fix body-scroll-lock blocking cart/nav scroll on iOS ──
     The theme's bodyScrollLock.disableBodyScroll() adds a touchmove
     listener on document that calls preventDefault() on all touch
     moves except TEXTAREA. It checks an element attribute
     data-body-scroll-lock-ignore or the allowTouchMove callback.

     We mark our scrollable containers so body-scroll-lock allows them.
     body-scroll-lock v3+ checks for [data-body-scroll-lock-ignore]. */
  function markScrollable() {
    var targets = document.querySelectorAll(
      '.cart__table, .cart__table-body, .nav-inner, .cart__form'
    );
    targets.forEach(function (el) {
      el.setAttribute('data-body-scroll-lock-ignore', '');
    });
  }

  /* Mark on load and after cart renders */
  markScrollable();
  document.addEventListener('theme:cart:change', markScrollable);
  document.addEventListener('theme:cart-close', markScrollable);

  /* Also observe DOM changes inside the drawer to catch AJAX cart renders */
  var drawerObserver = new MutationObserver(markScrollable);
  drawerObserver.observe(drawer, { childList: true, subtree: true });

  /* Fallback: intercept touchmove BEFORE body-scroll-lock can
     preventDefault(). We add a capturing listener on the scrollable
     elements that stops propagation so the library's document-level
     listener never sees the event. */
  function addScrollFix(selector) {
    /* Use MutationObserver since cart content is rendered via AJAX */
    function attach() {
      var els = document.querySelectorAll(selector);
      els.forEach(function (el) {
        if (el._scrollFixed) return;
        el._scrollFixed = true;
        el.addEventListener('touchmove', function (e) {
          e.stopPropagation();
        }, { passive: true });
      });
    }
    attach();
    var obs = new MutationObserver(attach);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  addScrollFix('.cart__table');
  addScrollFix('.cart__table-body');
  addScrollFix('.nav-inner');

  /* ── Backdrop overlay for closing cart ── */
  var backdrop = document.createElement('div');
  backdrop.className = 'tummy-cart-backdrop';
  drawer.insertBefore(backdrop, drawer.firstChild);

  backdrop.addEventListener('click', function () {
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.click();
  });

  /* ── Force cart drawer on mobile ── */
  var cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      var w = window.innerWidth || document.documentElement.clientWidth;
      if (w <= 767) {
        e.preventDefault();
        e.stopPropagation();
        if (window.cart) {
          if (document.body.classList.contains('cart--is-visible')) {
            window.cart.closeCartDrawer();
          } else {
            window.cart.openCartDrawer();
          }
        }
      }
    });
  }

  /* ── Kill page-slide on mobile hamburger nav ── */
  function killPageSlide() {
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (w > 767) return;

    var targets = [
      document.querySelector('[data-body-wrap]'),
      document.querySelector('.shopify-section-header'),
      document.querySelector('.shopify-section-header > header'),
      document.querySelector('.shopify-section-header header'),
      document.querySelector('[data-site-alert]'),
      document.querySelector('[data-shop-bar]')
    ];

    targets.forEach(function (el) {
      if (el) el.style.transform = 'none';
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'class') {
        if (document.body.classList.contains('nav--is-visible')) {
          requestAnimationFrame(function () {
            requestAnimationFrame(killPageSlide);
          });
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* ══════════════════════════════════════════
     Drag-to-dismiss for bottom sheet panels
     ══════════════════════════════════════════ */
  function setupDragToDismiss(panel, onClose) {
    if (!panel) return;

    var startY = 0;
    var currentY = 0;
    var isDragging = false;
    var threshold = 80; /* px to drag before closing */

    panel.addEventListener('touchstart', function (e) {
      /* Never drag if touching scrollable content */
      if (e.target.closest('.cart__table, .cart__form, .nav-inner, .menu')) return;

      /* Only drag from the top 60px (handle + header area) */
      var touch = e.touches[0];
      var rect = panel.getBoundingClientRect();
      var offsetY = touch.clientY - rect.top;
      if (offsetY > 60) return;

      startY = touch.clientY;
      currentY = startY;
      isDragging = true;
      panel.style.transition = 'none';
    }, { passive: true });

    panel.addEventListener('touchmove', function (e) {
      if (!isDragging) return;

      currentY = e.touches[0].clientY;
      var deltaY = currentY - startY;

      /* Only allow dragging downward */
      if (deltaY < 0) deltaY = 0;

      panel.style.transform = 'translateY(' + deltaY + 'px)';
    }, { passive: true });

    panel.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;

      var deltaY = currentY - startY;

      /* Restore transition */
      panel.style.transition = '';

      if (deltaY > threshold) {
        /* Dismiss */
        panel.style.transform = '';
        onClose();
      } else {
        /* Snap back */
        panel.style.transform = 'translateY(0)';
        /* Clean up inline transform after animation */
        setTimeout(function () {
          panel.style.transform = '';
        }, 350);
      }
    });
  }

  /* ── Cart drawer: drag to dismiss on mobile ── */
  var cartScroll = drawer.querySelector('.scroll');
  setupDragToDismiss(cartScroll, function () {
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.click();
  });

  /* ── Hamburger nav: drag to dismiss on mobile ── */
  var navPanel = document.querySelector('.nav-hamburger');
  setupDragToDismiss(navPanel, function () {
    var menuClose = document.querySelector('.nav-mobile-close[data-menu-toggle]');
    if (menuClose) menuClose.click();
  });
})();
